'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomChatName = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('./keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCustomChatName = exports.getCustomChatName = (0, _getIn2.default)(_keyPaths.CUSTOM_CHAT_NAME);